import React from "react";
import { Box, Stack, Typography, Link } from "@mui/material";

export const IsEmailVerified = () => {
  return (
    <Box>
      <Stack
        sx={{
          position: "absolute",
          top: "30%",
          alignItems: "center",
          justifyContent: "center",
        }}
        spacing={4}
      >
        <img src="/images/message_sent.svg" alt="Email sent" />
        <Typography width="85%" textAlign="center">
          A link has been sent to your email address:{" "}
          <Link href="#" underline="none">
            {'fortune@gmail.com'}
          </Link>
          . Please verify your account by clicking the link sent to your
          inbox.
        </Typography>
      </Stack>
    </Box>
  );
};
